import Modal from '@/shared/ui/Modal';
import { useProfile } from '@/routes/Providers/ProfileProvider';
import ModalGDPRContent from './ModalGDPRContent';

export default function GDPRModal() {
  const { profile } = useProfile();
  if (!profile || (profile.GDPR != null && profile.GDPR !== '')) {
    return null;
  }
  return (
    <Modal>
      <ModalGDPRContent />
    </Modal>
  );
}
